import React from "react";
import {
  Box,
  Botao,
  Alerta,
  TipoAlerta,
  Form,
  CampoTexto,
  Combo,
  TipoBotao,
} from "@intechprev/componentes-web";
import { RecadastramentoService } from "../../services";
import { WebRecadParticipanteDadosEntidade, EstadoCivilEntidade } from "../../entidades";
import { ArquivoUpload, ArquivoUploadItem } from "./ArquivoUpload";
import { Passos } from ".";

interface Props {
  setDadosPasso: any;
  Dados: any;
  DadosOriginais: WebRecadParticipanteDadosEntidade;
  HouveAlteracao: any;
  ListaArquivo: Array<ArquivoUploadItem>;
  setListaArquivo: any;
  Avancar: () => void;
  Voltar: () => void;
  NumeroPassoAtual: number;
}

interface State {
  ListaEstadoCivil: Array<EstadoCivilEntidade>;
  ListaEstadoCivilObrigatorio: Array<string>;
  ListaEstadoCivilObrigatorioArquivo: Array<string>;
  EstadoCivil: string;
  NomeConjuge: string;
  CPFConjuge: string;
}

export class Passo3 extends React.Component<Props, State> {
  private form = React.createRef<Form>();
  private alerta = React.createRef<Alerta>();
  private arquivo = React.createRef<ArquivoUpload>();

  constructor(props: Props) {
    super(props);

    this.state = {
      ListaEstadoCivil: new Array<EstadoCivilEntidade>(),
      ListaEstadoCivilObrigatorio: ["2", "6", "7"],
      ListaEstadoCivilObrigatorioArquivo: ["2", "3", "6", "7"],
      EstadoCivil: "",
      NomeConjuge: "",
      CPFConjuge: "",
    };
  }

  componentDidMount = async () => {
    try {
      // this.page.current.loading(false);

      const ListaEstadoCivil = await RecadastramentoService.BuscarListaEstadoCivil();

      const EstadoCivil = this.props.Dados.EstadoCivil || this.props.DadosOriginais.CD_ESTADO_CIVIL || "";

      const MostrarDadosOriginais = this.state.ListaEstadoCivilObrigatorio.includes(EstadoCivil);

      const NomeConjuge = MostrarDadosOriginais ? this.props.DadosOriginais.NOME_CONJUGE || "" : this.props.Dados.NomeConjuge;
      const CPFConjuge = MostrarDadosOriginais ? this.props.DadosOriginais.CPF_CONJUGE || "" : this.props.Dados.CPFConjuge;

      this.setState({
        ListaEstadoCivil,
        EstadoCivil,
        NomeConjuge,
        CPFConjuge,
      });
    } catch (err) {
      await this.alerta.current.adicionarErro(err.response ? err.response.data : err);
    }
  };

  ObrigatoriedadeCampos = () => {
    return this.state.ListaEstadoCivilObrigatorio.includes(this.state.EstadoCivil);
  };

  CompararDados = () => {
    const MostrarDadosOriginais = this.state.ListaEstadoCivilObrigatorio.includes(this.state.EstadoCivil);

    const NomeConjuge = MostrarDadosOriginais ? this.props.DadosOriginais.NOME_CONJUGE || "" : this.props.Dados.NomeConjuge;
    const CPFConjuge = MostrarDadosOriginais ? this.props.DadosOriginais.CPF_CONJUGE || "" : this.props.Dados.CPFConjuge;

    return (
      this.props.HouveAlteracao(this.props.DadosOriginais.CD_ESTADO_CIVIL, this.state.EstadoCivil) ||
      this.props.HouveAlteracao(NomeConjuge, this.state.NomeConjuge) ||
      this.props.HouveAlteracao(CPFConjuge, this.state.CPFConjuge)
    );
  };

  SalvarDados = () => {
    const d = {
      EstadoCivil: this.state.EstadoCivil,
      NomeConjuge: this.state.NomeConjuge,
      CPFConjuge: this.state.CPFConjuge,
    };
    this.props.setDadosPasso(Passos.Passo3, d);
  };

  Voltar = () => {
    this.SalvarDados();
    this.props.Voltar();
  };

  Proximo = async () => {
    try {
      await this.alerta.current.limparErros();
      await this.form.current.validar();
      this.arquivo.current.MostrarAviso(false);

      if (this.form.current.isValido()) {
        if (this.state.CPFConjuge) await RecadastramentoService.ValidarCpf(this.state.CPFConjuge);

        if (this.PrecisaEnvarArquivo()) {
          await this.alerta.current.adicionarErro("O envio de pelo menos um documento é obrigatório.");
          this.arquivo.current.MostrarAviso(true);
        } else {
          this.SalvarDados();
          this.props.Avancar();
        }
      }
    } catch (err) {
      await this.alerta.current.adicionarErro(err.response ? err.response.data : err);
    }
  };

  PrecisaEnvarArquivo = () => {
    const EstadoCivilObrigatorioArquivo = this.state.ListaEstadoCivilObrigatorioArquivo.includes(this.state.EstadoCivil);
    const ListaArquivoPasso = this.props.ListaArquivo.filter((arquivo) => arquivo.Passo === Passos.Passo3);

    return EstadoCivilObrigatorioArquivo && this.CompararDados() && ListaArquivoPasso.length === 0;
  };

  render() {
    return (
      <Box titulo={`Passo ${this.props.NumeroPassoAtual} - Estado Civil`}>
        <Form ref={this.form}>
          <Combo
            contexto={this}
            titulo={"Estado Civil"}
            nome={"EstadoCivil"}
            valor={this.state.EstadoCivil}
            opcoes={this.state.ListaEstadoCivil}
            nomeMembro={"DS_ESTADO_CIVIL"}
            valorMembro={"CD_ESTADO_CIVIL"}
            obrigatorio
          />

          <CampoTexto
            contexto={this}
            nome={"NomeConjuge"}
            titulo={"Nome do Conjuge"}
            obrigatorio={this.ObrigatoriedadeCampos()}
            max={40}
            valor={this.state.NomeConjuge}
          />

          <CampoTexto
            contexto={this}
            nome={"CPFConjuge"}
            titulo={"CPF do Conjuge"}
            obrigatorio={this.ObrigatoriedadeCampos()}
            valor={this.state.CPFConjuge}
            mascara={"999.999.999-99"}
          />

          <Alerta tipo={TipoAlerta.danger} ref={this.alerta} padraoFormulario />

          <ArquivoUpload
            ListaArquivo={this.props.ListaArquivo}
            PassoAtual={Passos.Passo3}
            setListaArquivo={this.props.setListaArquivo}
            texto={
              "Em caso de alteração do Estado Civil, por favor, anexar cópia da Certidão de Casamento ou da União Civil e de documento com foto e CPF do cônjuge ou companheiro."
            }
            ref={this.arquivo}
          />

          <Botao onClick={this.Voltar} titulo={"Voltar"} className={"m-2"} tipo={TipoBotao.light} icone={"angle-double-left"} iconeDireita />

          <Botao onClick={this.Proximo} titulo={"Continuar"} icone={"angle-double-right"} iconeDireita />
        </Form>
      </Box>
    );
  }
}
